import { AddressInput, IAddressInputAddress, IAddressInputProps } from '@opendoor/bricks';
import queryString from 'query-string';
import Raven from 'raven-js';
import * as React from 'react';

import { startAddressVerification } from '../api/addressInputHelpers';
import { Omit } from '../declarations';
import { CONSUMER_FE_URL, GOOGLE_MAPS_API_KEY } from '../helpers/globals';
import hotjar from '../helpers/hotjar';

type IAddressInputPropsWithoutCallbacks = Omit<
  IAddressInputProps,
  'onSubmit' | 'onChooseManualEntry' | 'googleMapsApiKey'
>;
export interface IProps extends IAddressInputPropsWithoutCallbacks {
  trackingKeywords?: string;
  partnerReferralId?: string;
}
export class SellerFlowAddressInput extends React.Component<IProps> {
  public componentDidMount() {
    if (this.props.channel) {
      try {
        hotjar('trigger', `offer_start_${this.props.channel}`);
        hotjar('tagRecording', [`offer_start_${this.props.channel}`]);
      } catch (e) {
        Raven.captureException(e);
      }
    }
  }

  public render() {
    return (
      <AddressInput
        onSubmit={this.startAddressVerification}
        onChooseManualEntry={this.startManualAddressVerification}
        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
        {...this.props}
      />
    );
  }

  private startAddressVerification = async (address: IAddressInputAddress) => {
    const error = await startAddressVerification(
      address,
      this.props.channel,
      this.props.trackingKeywords,
      this.props.partnerReferralId,
    );
    if (error) {
      window.location.href = '/error';
    }
  };

  private startManualAddressVerification = () => {
    const { channel, trackingKeywords, partnerReferralId } = this.props;
    const path = `${CONSUMER_FE_URL}/seller-lead/address-manual`;
    const query = queryString.stringify({
      channel,
      keywords: trackingKeywords,
      partner_referral: partnerReferralId,
    });
    window.location.assign(`${path}?${query}`);
  };
}
